import { bindable } from "aurelia-templating";
import { transient } from "aurelia-dependency-injection";
import { autoinject, noView } from "aurelia-framework";

@noView()
@autoinject()
@transient()
export class AsyncClickWithLoadingCustomAttribute {

    @bindable
    public click: ($event) => any;

    @bindable
    public loadingProp: string = "loading";

    constructor(private element: Element) {}

    internalClick = ($event) => {
        const viewModelElement = (<any>this.element).au && (<any>this.element).au.controller ? (<any>this.element).au.controller.viewModel : this.element;
        const loadingProp = this.loadingProp ? this.loadingProp : "loading";
        if (viewModelElement[loadingProp] || ((<any>this.element).au
            && (<any>this.element).au.controller
            && (<any>this.element).au.controller.viewModel["disabled"])) {
            return;
        }
        try {
            viewModelElement[loadingProp] = true;
            if (this.click) {
                const res = this.click($event);
                if (res instanceof Promise) {
                    res.then(() => {
                        viewModelElement[loadingProp] = false;
                    }).catch(() => {
                        viewModelElement[loadingProp] = false;
                    });
                } else {
                    viewModelElement[loadingProp] = false;
                }
            }
        } catch (exception) {
            viewModelElement[loadingProp] = false;
            console.error(exception);
        }
    }

    attached() {
        this.element.addEventListener("click", this.internalClick, false);
    }

    detached() {
        this.element.removeEventListener("click", this.internalClick, false);
    }
}